import React, { useEffect, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import "./index.css";

export default function Notification({
    message,
    type = "info",
    duration = 3000,
    onClose,
}) {
    const [visible, setVisible] = useState(false);
    const urgent = type === "error" || type === "warning";

    const hide = useCallback(() => {
        setVisible(false);
        if (onClose) {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        if (!message) {
            return undefined;
        }

        setVisible(true);
        if (duration === Infinity) {
            return undefined;
        }

        const timer = setTimeout(() => {
            hide();
        }, duration);

        return () => clearTimeout(timer);
    }, [message, duration, hide]);

    if (!message) {
        return null;
    }

    const notification = (
        <div
            className={`notification notification--glass notification--${type} ${visible ? "show" : ""}`}
            role={urgent ? "alert" : "status"}
            aria-live={urgent ? "assertive" : "polite"}
            aria-atomic="true"
        >
            <span className="notification__text">{message}</span>
            <button
                type="button"
                className="notification__close"
                aria-label="Close notification"
                onClick={hide}
            >
                ×
            </button>
        </div>
    );

    if (typeof document === "undefined") {
        return notification;
    }

    return createPortal(notification, document.getElementById("portal") || document.body);
}
